export default __webpack_public_path__ + "static/media/loader.311bdc49.gif";